// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__20hny","footer":"ReportModalFilter_footer__PJsqG"};